'use client';

export default function BlogPostDate({ publicationDate }: { publicationDate?: string | null }) {
  if (!publicationDate) {
    return null;
  }

  const formatedDate = new Date(publicationDate ?? '').toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return <>{formatedDate}</>;
}
